import React, {FC, useEffect, useMemo, useState} from "react";
import {Alert, Card, Col, Container, Row} from "react-bootstrap";
import {Trans, useTranslation} from "react-i18next";
import DSLR10 from './dslr10.jpg';
import DSLR11 from './dslr11.jpg';
import DSLR12 from './dslr12.jpg';
import DSLR13 from './dslr13.jpg';
import SP1 from './sp1.png';
import SP2 from './sp2.png';
import SP3 from './sp3.png';
import SP4 from './sp4.png';
import SP5 from './sp5.png';
import RestroomRequest from "./restroom/restroom-request.webp"
import RestroomLockScreen from "./restroom/restroom-lock-screen.webp"
import RestroomPinPrint from "./restroom/restroom-pin-print.webp"
import {useLocation, useParams} from "react-router-dom";

type FAQComponentProps = Record<string, unknown>

const FAQComponent: FC<FAQComponentProps> = () => {
    const {t} = useTranslation("info");
    const params = useParams()
    const location = useLocation()

    const [cat, setCat] = useState<number>(-1);
    const [open, setOpen] = useState<number>(-1);

    const categories = useMemo(() => [
        {
            title: t('info.t0'),
            entries: [{
                title: "info.f28.q1",
                size: 8,
                content: <>{t('info.f28.a1')}</>
            }, {
                title: "info.f18.q1",
                size: 4,
                content: <>{t('info.f18.a1')} <a href="https://moodle-exam.tu-darmstadt.de/">https://moodle-exam.tu-darmstadt.de/</a> {t('info.f18.a2')}</>
            }, {
                title: "info.f19.q1",
                size: 4,
                content: <>{t('info.f19.a1')} <a href="https://moodle-exam.tu-darmstadt.de/course/view.php?id=9">https://moodle-exam.tu-darmstadt.de/course/view.php?id=9</a>.</>
            }],
        }, {
            title: t('info.t1'),
            entries: [
                {
                    title: "info.f15.q1",
                    size: 4,
                    content: <>{t('info.f15.a1')}</>
                },
                {
                    title: "info.f17.q1",
                    size: 4,
                    content: <>{t('info.f17.a1')}</>
                }, {
                    title: "info.f2.q1",
                    size: 4,
                    content: <>{t('info.f2.a1')}</>
                }, {
                    title: "info.f3.q1",
                    size: 4,
                    content: <>{t('info.f3.a1')}</>
                }, {
                    title: "info.f4.q1",
                    size: 4,
                    content: <>{t('info.f4.a1')}</>
                }, {
                    title: "info.f7.q1",
                    size: 4,
                    content: <>{t('info.f7.a1')}</>
                }, {
                    title: "info.f14.q1",
                    size: 4,
                    content: <>{t('info.f14.a1')}</>
                }, {
                    title: "info.f8.q1",
                    size: 4,
                    content: <>{t('info.f8.a1')}</>
                }, {
                    title: "info.f20.q1",
                    size: 4,
                    content: <>{t('info.f20.a1')}</>
                }, {
                    title: "info.f21.q1",
                    size: 4,
                    content: <>{t('info.f21.a1')}</>
                }, {
                    title: "info.f22.q1",
                    size: 4,
                    content: <>{t('info.f22.a1')}</>
                }, {
                    title: "info.f25.q1",
                    size: 4,
                    content: <>{t('info.f25.a1')}</>
                }, {
                    title: "info.f11.q1",
                    size: 4,
                    content: <><Row><Col>{t('info.f11.a1')}<Card><Card.Img
                        src={DSLR12}></Card.Img></Card></Col></Row></>
                }, {
                    title: "info.f1.q1",
                    size: 12,
                    content: <><Row><Col>{t('info.f1.a1')}</Col><Col><Card><Card.Img
                        src={DSLR11}></Card.Img><Card.Body>{t('info.f1.f1')}.</Card.Body></Card></Col></Row></>
                }, {
                    title: "info.f32.q1",
                    size: 12,
                    content: <>
                        <ul>
                            <li>{t('info.f32.a1')}</li>
                            <li>{t('info.f32.a2')}</li>
                            <li>{t('info.f32.a3')} <b>{t('info.f32.a4')}</b> {t('info.f32.a5')}</li>
                        </ul>
                    </>
                },
            ],
        }, {
            title: t('info.t2'),
            entries: [
                {
                    title: "info.f6.q1",
                    size: 4,
                    content: <>{t('info.f6.a1')}</>
                }, {
                    title: "info.f29.q1",
                    size: 12,
                    content: <><Row><Col><Card><Card.Img
                        src={DSLR13}></Card.Img></Card></Col><Col>{t('info.f29.a1')}</Col><Col><Card><Card.Img
                        src={SP1}></Card.Img></Card></Col></Row></>
                }, {
                    title: "info.f30.q1",
                    size: 12,
                    content: <><Row><Col><Card><Card.Img
                        src={SP2}></Card.Img></Card></Col><Col>{t('info.f30.a1')}</Col><Col><Card><Card.Img
                        src={SP3}></Card.Img></Card></Col></Row></>
                }, {
                    title: "info.f5.q1",
                    size: 12,
                    content: <><Row><Col><Card><Card.Img
                        src={SP4}></Card.Img></Card></Col><Col>{t('info.f5.a1')}</Col><Col><Card><Card.Img
                        src={DSLR10}></Card.Img></Card></Col></Row></>
                }, {
                    title: "info.f31.q1",
                    size: 12,
                    content: <><Row><Col>{t('info.f31.a1')}
                        <p className="text-center mt-2">
                            <audio src="/locker.mp3" controls/>
                        </p>
                    </Col><Col><Card><Card.Img
                        src={SP5}></Card.Img></Card></Col></Row></>
                },
                // {
                //     title: "info.f24.q1",
                //     size: 4,
                //     content: <>{t('info.f24.a1')}</>
                // },
            ]
        }, {
            title: t('info.t3'),
            entries: [
                {
                    title: "info.f9.q1",
                    size: 4,
                    content: <>{t('info.f9.a1')}</>
                }, {
                    title: "info.f23.q1",
                    size: 4,
                    content: <>{t('info.f23.a1')}</>
                }, {
                    title: "info.f27.q1",
                    id: "restroom-break",
                    size: 12,
                    content: <>
                        <Alert variant="info">
                            <i className="bi bi-info-circle-fill me-2" aria-hidden="true"/>
                            {t("info.f27.intro")}
                        </Alert>
                        <div>
                            <div className="mb-4">
                                <p><Trans t={t} ns="info" i18nKey="info.f27.step1" components={{strong: <strong/>}}/></p>
                                <Card className="mx-auto" style={{maxWidth: "741px"}}>
                                    <img
                                        className="card-img-top"
                                        src={RestroomRequest}
                                        alt={t("info.f27.image1Alt")}
                                        loading="lazy"
                                    />
                                    <Card.Body className="small text-muted">
                                        {t("info.f27.image1Caption")}
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className="mb-4">
                                <p><Trans t={t} ns="info" i18nKey="info.f27.step2" components={{strong: <strong/>}}/></p>
                                <Card className="mx-auto" style={{maxWidth: "1000px"}}>
                                    <img
                                        className="card-img-top"
                                        src={RestroomLockScreen}
                                        alt={t("info.f27.image2Alt")}
                                        loading="lazy"
                                    />
                                    <Card.Body className="small text-muted">
                                        {t("info.f27.image2Caption")}
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className="mb-4">
                                <p><Trans t={t} ns="info" i18nKey="info.f27.step3" components={{strong: <strong/>}}/></p>
                                <Card className="mx-auto" style={{maxWidth: "900px"}}>
                                    <img
                                        className="card-img-top"
                                        src={RestroomPinPrint}
                                        alt={t("info.f27.image3Alt")}
                                        loading="lazy"
                                    />
                                    <Card.Body className="small text-muted">
                                        {t("info.f27.image3Caption")}
                                    </Card.Body>
                                </Card>
                            </div>
                            <div>
                                <p className="mb-0"><Trans t={t} ns="info" i18nKey="info.f27.step4" components={{strong: <strong/>}}/></p>
                            </div>
                        </div>
                        <p className="mt-4 mb-0">
                            <strong>{t("info.f27.emergencyTitle")}</strong>{" "}
                            {t("info.f27.emergencyText")}
                        </p>
                    </>
                }, {
                    title: "info.f34.q1",
                    size: 4,
                    content: <>{t('info.f34.a1')}</>
                },
            ]
        },
        // {
        //     //     title: t('info.t4'),
        //     //     entries: []
        //     // }, {
        //     title: t('info.t5'),
        //     entries: [
        //         {
        //             title: "info.f12.q1",
        //             size: 4,
        //             content: <>{t('info.f12.a1')}</>
        //         },
        //         {
        //             title: "info.f13.q1",
        //             size: 4,
        //             content: <>{t('info.f13.a1a')} <a href="https://www.tu-darmstadt.de/studieren/studierende_tu/studienorganisation_und_tucan/hilfe_und_faq/artikel_details_de_en_14403.de.jsp" target="_blank">{t('info.f13.a1b')}</a> {t('info.f13.a1c')}</>
        //         },
        //     ]
        // },
        {
            title: t('info.t6'),
            entries: [{
                    title: "info.f16.q1",
                    size: 12,
                    content: <Row>
                        <Col>
                            <h4>{t('booking.step3.policy2')}</h4>
                            <p>{t('booking.step3.policy3')} <b>{t('booking.step3.policy4')}</b> {t('booking.step3.policy5')}
                            </p>
                            <p>{t('booking.step3.policy6')}</p>
                            <p>{t('booking.step3.policy7')}</p>
                            <h4>{t('booking.step3.policy8')}</h4>
                            <p>{t('booking.step3.policy9')}</p>
                            <p>{t('booking.step3.policy10')}<br/>
                                {t('booking.step3.policy11')}
                                <ul>
                                    <li>{t('booking.step3.policy12')}</li>
                                    <li>{t('booking.step3.policy13')}</li>
                                </ul>
                            </p>
                            <p>{t('booking.step3.policy14')}</p>
                            <p>{t('booking.step3.policy15')}</p>
                        </Col>
                        <Col>
                            <h4>{t('booking.step3.policy16')}</h4>
                            <p>{t('booking.step3.policy17')}</p>
                            <p>{t('booking.step3.policy18')}</p>
                            <p><b>{t('booking.step3.policy19a')}
                                <b>{t('booking.step3.policy19b')}</b> {t('booking.step3.policy19c')}
                            </b></p>
                            <h4>{t('booking.step3.policy20')}</h4>
                            <p>{t('booking.step3.policy21')}</p>
                            <p>{t('booking.step3.policy22')}</p>
                            <p>{t('booking.step3.policy23a')} <b>{t('booking.step3.policy23b')}</b> {t('booking.step3.policy23c')} <b>{t('booking.step3.policy23d')}</b> {t('booking.step3.policy23e')}
                            </p>
                        </Col>
                    </Row>
                }
            ]
        }
    ], [t])

    useEffect(() => {
        const anchor = location.hash.slice(1)
        if (!anchor) return

        for (let categoryIndex = 0; categoryIndex < categories.length; categoryIndex++) {
            const entryIndex = categories[categoryIndex].entries.findIndex(
                (entry: any) => entry.id === anchor
            )
            if (entryIndex !== -1) {
                setCat(categoryIndex)
                setOpen(entryIndex)
                window.requestAnimationFrame(() => {
                    document.getElementById(anchor)?.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    })
                })
                return
            }
        }
    }, [categories, location.hash])

    const select = (catId: number = -1, openId: number = -1) => {
        setCat(catId)
        setOpen(openId)
    };
    return (<div className="component">
        <Container>
            <Row>
                <Col>
                    <Card>
                        <Card.Header><h1><i className="bi bi-question-circle"></i> {t('faq.title')}</h1></Card.Header>
                        <Card.Body>
                            <div>
                                {categories.map((category: any, idx: number) => (
                                    <Row className="mb-5 gy-3" key={category.title}>
                                        <h2>{category.title}</h2>
                                        <hr/>
                                        {category.entries.map((entry: any, idy: number) => (
                                            <Col
                                                sm={12}
                                                md={cat === idx && open === idy ? entry.size : 4}
                                                key={entry.title}
                                                id={entry.id}
                                            >
                                                <Card>
                                                    <Card.Header>
                                                        <button
                                                            type="button"
                                                            className="w-100 border-0 bg-transparent text-start p-0"
                                                            aria-expanded={cat === idx && open === idy}
                                                            aria-controls={`faq-answer-${idx}-${idy}`}
                                                            onClick={() => (
                                                                cat === idx && open === idy
                                                                    ? select()
                                                                    : select(idx, idy)
                                                            )}
                                                        >
                                                            {params.debug ? idy + " " + t(entry.title) : t(entry.title)}
                                                        </button>
                                                    </Card.Header>
                                                    {cat === idx && open === idy ? <Card.Body id={`faq-answer-${idx}-${idy}`}>
                                                        <div>
                                                            {entry.content}
                                                        </div>
                                                    </Card.Body> : null
                                                    }
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>))}</div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </div>)
}

export default FAQComponent
